var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCanada = function SvgCanada(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#canada_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M3.254 0h14.152v20H3.254z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D52B1E",
    d: "M-3.82 0h7.074v20H-3.82zm21.226 0h7.074v20h-7.07zM5.375 9.664l-.555.188 2.559 2.246c.195.574-.066.742-.234 1.047l2.773-.352-.066 2.793.578-.016-.13-2.773 2.782.332c-.172-.363-.324-.555-.168-1.133l2.555-2.129-.446-.164c-.367-.281.157-1.355.235-2.035 0 0-1.488.512-1.586.242l-.383-.73-1.355 1.492c-.149.035-.211-.024-.246-.149l.624-3.117-.992.559c-.082.039-.164.008-.218-.09l-.957-1.914-.985 1.988c-.074.07-.148.078-.21.032l-.946-.532.57 3.09c-.047.125-.156.156-.281.09l-1.3-1.473c-.169.274-.282.715-.509.817-.222.093-.976-.188-1.48-.297.172.62.71 1.652.371 1.992z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "canada_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-3 0h26.667v20H-3z"
  })))));
};
export default SvgCanada;